import React from 'react'
import { Image, MDX } from 'contentbricks'
import { getPartyDE } from 'swiss-party-colors'
interface Props {
  party: string
  name: string
  data: { competed: number; won: number; improved: number }
  locales: { competed: string; won: string; improved: string; munis: string }
}

export const PartySegment = ({ party, name, data, locales }: Props) => (
  <div className='partySegment'>
    <div className='dashboard'>
      <div className='ui text container'>
        <div className='ui stackable grid'>
          <div className='four wide column partyname'>
            <h2
              className=' ui infographic header'
              style={{ color: getPartyDE(party).color }}
            >
              {name}
            </h2>
          </div>
          <div className='twelve wide column dataColumn'>
            <div className='ui grid'>
              <div className='ui row'>
                <div className='seven wide column label'>
                  {locales.competed}:{' '}
                </div>
                <div className='two wide column value'>
                  <b>{data.competed}</b>
                </div>
                <div className='five wide column unit'> {locales.munis}</div>
              </div>

              <div className='ui row'>
                <div className='seven wide column label'>{locales.won}: </div>
                <div className='two wide column value'>
                  <b>
                    {((data.won * 100) / data.competed)
                      .toFixed(1)
                      .replace('.', ',')}
                  </b>
                </div>
                <div className='five wide column unit'>%</div>
              </div>

              <div className='ui row'>
                <div className='seven wide column label'>
                  {locales.improved}:{' '}
                </div>
                <div className='two wide column value'>
                  <b>
                    {((data.improved * 100) / data.competed)
                      .toFixed(1)
                      .replace('.', ',')}
                  </b>
                </div>
                <div className='five wide column unit'>%</div>
              </div>
            </div>{' '}
          </div>
        </div>
      </div>
      <div className='ui text container'>
        <div className='ui stackable grid'>
          {/* <div className='four wide column ' /> */}
          <div className='sixteen wide column imageTitle'>
          {locales.maptitle}

          </div>
        </div>
      </div>
      <div className='ui stackable centered grid'>
        <div className='sixteen wide desktop column chartColumn'>
          <Image
            file={'images/maps/gewinner-verlierer-gemeinden_' + party + '.jpg'}
            className='map'
          />
        </div>
      </div>
      <div className='ui text container'>
        <div className='ui stackable grid'>
          {/* <div className='four wide column ' /> */}
          <div className='sixteen wide column imageTitle'>
            {locales.charttitle}
          </div>
        </div>
      </div>
      <div className='ui stackable centered grid'>
        <div className='sixteen wide desktop column chartColumn'>
          <Image
            file={'images/charts/waehlerstimmen_' + party + '.svg'}
            className='chart'
          />
        </div>
      </div>
    </div>
    <div
      className='ui text container mdxText'
      style={{
        margin: '0 !important',
        marginRight: '0 !important',
        padding: '0 !important'
      }}
    >
      <MDX file={require('text/' + party + '.mdx')} />
    </div>
  </div>
)
